<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="CASOS" key="1">
      <g-master :name="master.endpoint"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                modalWidth="80%"
                @action="masterAction"
                ref="master"
      >
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-lookup :label="$t('Empleado')"
                        style="width: 100%"
                        :formItemConfig="fiOptions"
                        endpoint="empleados"
                        :decorator="['id_emp', { rules: [{ required: false, message: 'Valor requerido' }] }]">
              </g-lookup>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Estado 1')"
                          :formItemConfig="fiOptions"
                          :decorator="['status1', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="estado1">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Estado 2')"
                          :formItemConfig="fiOptions"
                          :decorator="['status2', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="estado2">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Origen')"
                          :formItemConfig="fiOptions"
                          :decorator="['origin', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="origen">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Reubicación')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['relocation', {valuePropName: 'checked', rules: [{ required: false, message: 'Valor requerido' }] }]">
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-show="isVisibleReubicacion" v-bind="colOptions">
              <a-form-item :label="$t('Fecha reubicación')" v-bind="fiOptions">
                <a-date-picker style="width: 100%"
                               valueFormat="Y-MM-DD HH:mm:ss"
                               v-decorator="['date_reloc', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-show="isVisibleReubicacion" v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Obs. Reubicación')">
                <a-textarea auto-size
                            v-decorator="['obs_reloc', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Reasignación')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['reassignment', {valuePropName: 'checked', rules: [{ required: false, message: 'Valor requerido' }] }]">
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-show="isVisibleReasignacion" v-bind="colOptions">
              <a-form-item :label="$t('Fecha reasignación')" v-bind="fiOptions">
                <a-date-picker style="width: 100%"
                               valueFormat="Y-MM-DD HH:mm:ss"
                               v-decorator="['date_reass', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-show="isVisibleReasignacion" v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Obs. Reasignación')">
                <a-textarea
                  auto-size
                  v-decorator="['obs_reass', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('PVE Audio')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['pve_audio', {valuePropName: 'checked' }]">
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('PVE Osteomuscular')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['pve_osteomuscular', {valuePropName: 'checked' }]">
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('PVE Psicosocial')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['pve_psicosocial', {valuePropName: 'checked' }]">
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Otro PVE')" :has-feedback="false">
                <a-checkbox v-decorator="['pve_otro', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-show="isVisiblePVE" v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('PVE')"
                          :formItemConfig="fiOptions"
                          :decorator="['pve_otro_det', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="pve">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Fecha Inicio Caso')" v-bind="fiOptions">
                <a-date-picker style="width: 100%"
                               valueFormat="Y-MM-DD HH:mm:ss"
                               v-decorator="['date_class', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Desc. Caso')">
                <a-textarea auto-size
                            v-decorator="['observation', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Porcentaje PCL')">
                <a-input-number
                  style="width: 100%"
                  v-decorator="['percentage_pgl', { rules: [{ required: false}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Visita domiciliaria')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['home_visit', {valuePropName: 'checked', rules: [{ required: false, message: 'Valor requerido' }] }]">
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Semanas cotizadas')">
                <a-input-number
                  style="width: 100%"
                  v-decorator="['week_listed', { rules: [{ required: false}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Reintegrarse')"
                          :formItemConfig="fiOptions"
                          :decorator="['relocation_type', { rules: [{ required: false }] }]"
                          :params="reintegracion">
              </g-dropdown>
            </a-col>
          </a-row>
        </template>
      </g-master>
      <seguridad-salud-detalle-tabs v-if="idCase" :id_case="idCase"></seguridad-salud-detalle-tabs>

      <span v-else>
            <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="Detalles" key="1">
            Seleccione un caso para ver más.
          </a-tab-pane>
      </a-tabs></span>

    </a-tab-pane>
  </a-tabs>
</template>
<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    data () {
      return {
        isVisiblePVE: false,
        isVisibleReubicacion: false,
        isVisibleReasignacion: false,
        estado1: {h_lookup_type: 'ESTADO_CASE', use_code: true},
        estado2: {h_lookup_type: 'STATUS_CASO', use_code: true},
        origen: {h_lookup_type: 'ORIGEN', use_code: true},
        pve: {h_lookup_type: 'PVE', use_code: true},
        reintegracion: {h_lookup_type: 'REINTEGRACION_CASO', use_code: true},
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          valoresExpandidos: [
            {label: 'Porcentaje PCL', column: 'percentage_pgl'},
            {label: 'PVE Audio', column: 'audio_desc'},
            {label: 'PVE Osteomuscular', column: 'osteomuscular_desc'},
            {label: 'PVE Otro', column: 'otro_desc'},
            {label: 'PVE Psicosocial', column: 'psico_desc'},
            {label: 'Porcentaje PCL', column: 'percentage_pgl'},
            {label: 'Jefe encargado', column: 'boss'},
            {label: 'Oficina', column: 'locationempl'},
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado en', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado en', column: 'modified_on'}
          ],
          endpoint: 'cases',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id_case'
            },
            columns: [
              {title: 'ID Caso', dataIndex: 'id_case', sorter: true},
              {title: 'ID del empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre completo', dataIndex: 'nombre', sorter: true},
              {title: 'Cargo empleado', dataIndex: 'cargo', sorter: true},

              {title: 'Estado 1', dataIndex: 'desestatus1', sorter: true},
              {title: 'Estado 2', dataIndex: 'desestatus2', sorter: true},
              {title: 'Origen', dataIndex: 'desorigen', sorter: true},
              {title: 'PVE', dataIndex: 'despve', sorter: true},
              {title: 'Fecha de calificación', dataIndex: 'fecha_calificacion', sorter: true},
              {title: 'Fecha de reubicación', dataIndex: 'fecha_reubicacion', sorter: true},
              {title: 'Observación reubicación', dataIndex: 'obs_reloc', sorter: true},
              {title: 'Fecha de reasignación', dataIndex: 'fecha_reasignacion', sorter: true},
              {title: 'Observación reasignación', dataIndex: 'obs_reass', sorter: true},
              {title: 'Observación caso', dataIndex: 'observation', sorter: true},
              {title: 'Visita domiciliaria', dataIndex: 'home_visit_desc', sorter: true}
            ],
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    if (record.status1 === 'ABI') {
                      return true
                    } else {
                      return false
                    }
                  }
                }
              ]
            }
          },
          modalFieldsSetup: [
            {name: 'id_emp'},
            {name: 'status1'},
            {name: 'status2'},
            {name: 'pve_audio', type: 'boolean'},
            {name: 'pve_osteomuscular', type: 'boolean'},
            {name: 'pve_otro', type: 'boolean'},
            {name: 'date_class'},
            {name: 'date_reloc'},
            {name: 'obs_reloc'},
            {name: 'date_reass'},
            {name: 'pve_otro_det'},
            {name: 'obs_reass'},
            {name: 'origin'},
            {name: 'relocation', type: 'boolean'},
            {name: 'reassignment', type: 'boolean'},
            {name: 'pve_psicosocial', type: 'boolean'},
            {name: 'observation'},
            {name: 'percentage_pgl'},
            {name: 'home_visit'}
          ]
        }
      }
    },
    computed: {
      idCase () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id_case : null
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.isVisiblePVE = false
            this.isVisibleReubicacion = false
            this.isVisibleReasignacion = false
            break
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (!JsUtils.isEmpty(action.changedFields.pve_otro)) {
              if (action.changedFields.pve_otro.value) {
                this.isVisiblePVE = true
              } else {
                this.isVisiblePVE = false
              }
            }
            if (!JsUtils.isEmpty(action.changedFields.relocation)) {
              if (action.changedFields.relocation.value) {
                this.isVisibleReubicacion = true
              } else {
                this.isVisibleReubicacion = false
              }
            }
            if (!JsUtils.isEmpty(action.changedFields.reassignment)) {
              if (action.changedFields.reassignment.value) {
                this.isVisibleReasignacion = true
              } else {
                this.isVisibleReasignacion = false
              }
            }
            break

          case 'masterEdit':
            if (action.record.pve_otro) {
              this.isVisiblePVE = true
            } else {
              this.isVisiblePVE = false
            }

            if (action.record.relocation) {
              this.isVisibleReubicacion = true
            } else {
              this.isVisibleReubicacion = false
            }

            if (action.record.reassignment) {
              this.isVisibleReasignacion = true
            } else {
              this.isVisibleReasignacion = false
            }
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/Casos.vue